<template>

    <v-content>
        <v-container fluid>
 
            <panelcontainer>
                <div class="headline" slot="headline">Reçete / Wetend</div>
                <div slot="actions">
                    <v-btn tile color="indigo" dark @click="editItem()">
                        <v-icon>{{mdiPlus}}</v-icon> Yeni Reçete Ekle
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Reçete listesi yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr style="font-weight:300 !important"> 
                                <th colspan="2"><v-text-field   v-model="filterTextSubject" outlined dense clearable hide-details placeholder="Ara"></v-text-field></th>
                                <th colspan="1"><v-text-field smallx v-model="filterTextProduct" outlined clearable dense hide-details placeholder="Ara"></v-text-field></th>  
                                <th colspan="2"><v-text-field smallx v-model="filterTextColor" outlined clearable dense hide-details placeholder="Ara"></v-text-field></th>  
                            </tr>
                            <tr>
                                <th width="20px">#</th>
                                <th>Konu</th>
                                <th>Ürün</th> 
                                <th>Renk</th> 
                                <th style="width:1%;" class="actions"></th>
                                <th style="width:1%;" class="actions"></th>
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(item, itemIndex) in getItems" :key="itemIndex"  >
                                <td class="cell-detail">
                                    1
                                </td>
                                <td class="cell-detail">
                                    <span><b>{{item.title}}</b></span>
                                    <span class="cell-detail-description">{{users[item.user_id].fullname}}</span>
                                </td>
                                <td class="cell-detail">
                                    <span><b>{{item.product_name}}</b></span>
                                    <span class="cell-detail-description">{{item.product_no}}</span>
                                </td> 
                                <td class="cell-detail">
                                    <span><b>{{item.color}}</b></span>
                                    <span class="cell-detail-description">{{item.date_text}}</span>
                                </td> 
								<td class="actions">
									<v-btn small icon color="green" dark dense @click="askForCopy(item)"> <v-icon>{{mdiContentCopy}}</v-icon> </v-btn>
								</td>
								<td class="actions">
									<v-btn small icon color="indigo" dark dense @click="editItem(item)"> <v-icon>{{mdiSquareEditOutline}}</v-icon> </v-btn>
								</td>
								<td class="actions">
									<v-btn small icon color="error" dark dense @click="askForRemove(item)"> <v-icon>{{mdiCloseCircle}}</v-icon> </v-btn>
								</td>
                            </tr>
                        </tbody>
                    </table> 
                </template>
            </panelcontainer>
 
                <v-dialog v-model="dialogRemove" max-width="350">
                    <v-card>
                        <v-card-title class="headline" color="error"> Sil</v-card-title>
						<v-card-text><b>{{item.title}}</b> başlıklı içeriği silmek itediğine emin misin ?</v-card-text>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForRemove()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="removeItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogCopy" max-width="350">
                    <v-card>
                        <v-card-title class="headline" color="error">Kopyala</v-card-title>
						<v-card-text>
							<b>{{item.title}}</b> başlıklı içeriğin bir kopyasını oluştur
							<br>
							<br>
							<v-text-field v-model="itemCopy.title" outlined dense hide-details label="Bir başlık belirle"  x-small></v-text-field>
						</v-card-text>
                        <v-card-actions>
                            <v-btn color="green darken-1" text @click="closeForCopy()"> Vazgeç </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="error darken-1" text @click="copyItem()"> EMİNİM </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>



        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiAccountEdit,
        mdiContentCopy,
        mdiSquareEditOutline, 
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiAccountEdit: mdiAccountEdit,
            mdiContentCopy: mdiContentCopy,
            mdiSquareEditOutline: mdiSquareEditOutline, 

			isLoading: false, 
			dialogCopy: false,
			
			users : {},
			items: [  ],
			item : {},
			itemCopy : {},
			filterTextSubject : "",
			filterTextProduct : "",
			filterTextColor : "",
			_label_author_name : ""
		}),
		mounted(){
			this.loadUsers();
		},
        methods: {
			loadUsers(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					this.users = {};
					for(var i in response.body){
						this.users[response.body[i].id] = response.body[i]
					}  
					this.loadItems();
				}) 
			},
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/recipes/wetend/").then(response => {  
					this.items = response.body; 
					this.isLoading = false; 
				})  
			},
            editItem(item) {
				var link = "/recipes/wetend/edit/"
				if(item){
					link += "?id=" + item.id
				} 
				window.open(link, '_blank'); 
            },
            closeItem() {
                this.dialogEditor = false
            },
			askForRemove(item){
				this.item = JSON.parse(JSON.stringify(item))
				this.dialogRemove = true;
			},
			removeItem(item){
				this.$http.post( process.env.VUE_APP_API_URL + "/recipes/wetend/remove", this.item).then(response => {  
					this.loadItems()
					this.dialogRemove = false;
				})
			},
			closeForRemove(){
				this.dialogRemove = false;
			},
			askForCopy(item){
				this.item = JSON.parse(JSON.stringify(item))
				this.item.title += " Kopyası"
				this.itemCopy = JSON.parse(JSON.stringify(this.item))
				this.dialogCopy = true;
			},
			copyItem(item){
				this.$http.post( process.env.VUE_APP_API_URL + "/recipes/wetend/copy", this.itemCopy).then(response => {  
					this.loadItems()
				this.dialogCopy = false;
				}) 
			}, 
			closeForCopy(){
				this.dialogCopy = false;
			},
		
        },
        computed: {
            getItems() {
				var items = []; 
				var filterTextSubject = this.filterTextSubject == null || this.filterTextSubject == "" ? "" : this.filterTextSubject.seoUrl(); 
				var filterTextProduct = this.filterTextProduct == null || this.filterTextProduct == "" ? "" : this.filterTextProduct.seoUrl(); 
				var filterTextColor = this.filterTextColor == null || this.filterTextColor == "" ? "" : this.filterTextColor.seoUrl(); 
				items = this.items.filter( function(item) { 
					if((filterTextSubject != null && filterTextSubject != "")){
						if( 
							item.title.seoUrl().indexOf(filterTextSubject) < 0 
						){ return false; }
					}
					if((filterTextProduct != null && filterTextProduct != "")){
						if( 
							item.product_name.seoUrl().indexOf(filterTextProduct) < 0 && 
							item.product_no.seoUrl().indexOf(filterTextProduct) < 0 
						){ return false; }
					}
					if((filterTextColor != null && filterTextColor != "")){
						if( 
							item.color.seoUrl().indexOf(filterTextColor) < 0 && 
							item.date_text.seoUrl().indexOf(filterTextColor) < 0 
						){ return false; }
					}
					return true;
				}) 
				return items;
            }
        }
    }
</script>

<style>

</style>